export default "__VITE_ASSET__Bss8UBGc__"